
import { useState } from 'react';
import { deleteSuggestion } from '@/utils/suggestions/deleteUtils';
import { toast } from 'sonner';

export const useDeleteSuggestion = (onSuccess?: () => void) => {
  const [deleteConfirmation, setDeleteConfirmation] = useState<{ 
    isOpen: boolean; 
    suggestionId: string | null;
    isDeleting: boolean;
  }>({
    isOpen: false,
    suggestionId: null,
    isDeleting: false
  });

  const handleDeleteClick = (id: string) => {
    if (!id) {
      console.error('Invalid suggestion ID provided for deletion');
      toast.error('Kunne ikke slette tipset. Ugyldig ID.');
      return;
    }

    setDeleteConfirmation({
      isOpen: true,
      suggestionId: id,
      isDeleting: false
    });
  };
  
  const handleConfirmDelete = async () => {
    if (!deleteConfirmation.suggestionId) {
      console.error('No suggestion ID available for deletion');
      setDeleteConfirmation({ isOpen: false, suggestionId: null, isDeleting: false });
      return;
    }
    
    try {
      // Set deleting state to prevent multiple clicks
      setDeleteConfirmation(prev => ({ ...prev, isDeleting: true }));
      
      const id = deleteConfirmation.suggestionId;
      console.log(`Initiating deletion of suggestion ${id}`);
      
      // Call the delete function - this will throw if it fails
      await deleteSuggestion(id);
      
      // Close the dialog immediately on successful deletion
      setDeleteConfirmation({ isOpen: false, suggestionId: null, isDeleting: false });
      
      // Trigger success callback to refetch data
      console.log('Deletion successful, triggering refetch');
      onSuccess?.();
      
    } catch (error) {
      console.error('Error in handleConfirmDelete:', error);
      // Error message is already shown by deleteSuggestion function
      // Reset the confirmation dialog state but keep it open to allow retry
      setDeleteConfirmation(prev => ({ ...prev, isDeleting: false }));
    }
  };
  
  const handleCancelDelete = () => {
    if (!deleteConfirmation.isDeleting) {
      setDeleteConfirmation({ isOpen: false, suggestionId: null, isDeleting: false });
    }
  };

  return {
    deleteConfirmation,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete
  };
};
